import clsx from "clsx";
import { SvgSpeakerFilled } from "ui/svgs";
import { Popover } from "antd";
import { IpSpeakerType } from "lib/types";

export default function SpeakerItem({
  objSpeaker,
  onClickSpeaker,
  unSelectable,
  unSelectedPopText,
}: {
  objSpeaker: IpSpeakerType;

  onClickSpeaker?: (objSpeaker: IpSpeakerType) => void;
  unSelectable?: boolean;
  unSelectedPopText?: string;
}) {
  async function handleClickSpeaker() {
    onClickSpeaker?.(objSpeaker);
  }

  return (
    <>
      <Popover content={unSelectable ? unSelectedPopText : null}>
        <button
          onClick={handleClickSpeaker}
          aria-disabled={unSelectable}
          disabled={unSelectable}
          className="disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <div className="relative rounded-lg bg-gray-100">
            <div className="w-full aspect-video object-cover rounded-lg overflow-hidden flex items-center justify-center">
              <SvgSpeakerFilled width={"28"} color="#717171" />
            </div>
            <p className="absolute bottom-1 left-1 rounded-lg px-2 py-1 text-xs text-center text-white bg-neutral-800 bg-opacity-75 text-nowrap max-w-[80%] overflow-hidden break-words text-ellipsis break-all">
              <span
                className={clsx(
                  "inline-block w-2 h-2 rounded-full mr-1",
                  objSpeaker.status == "online"
                    ? "bg-emerald-400"
                    : "bg-red-500",
                )}
              ></span>
              {objSpeaker.name}
            </p>
          </div>
        </button>
      </Popover>
    </>
  );
}
